
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface LoginPromptDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LoginPromptDialog = ({ isOpen, onClose }: LoginPromptDialogProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground h-6 w-6"
          onClick={onClose}
        >
          <X className="h-3 w-3" />
          <span className="sr-only">Close</span>
        </Button>
        <DialogHeader>
          <DialogTitle>Join FluxVoid - It's Free!</DialogTitle>
          <DialogDescription className="pt-2">
            Sign-up today to reserve your username & claim a limited pioneer badge!
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col sm:flex-row gap-2 pt-4">
          <Button
            variant="outline"
            className="flex-1 opacity-50 cursor-not-allowed"
            onClick={() => navigate("/signin")}
            disabled
          >
            Sign In
          </Button>
          <Button
            className="flex-1 bg-flux-cyan hover:bg-flux-cyan/90 text-background"
            onClick={() => navigate("/signup")}
          >
            Sign Up
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
